import { Action, createReducer, on } from '@ngrx/store';
import { ActionReducer } from '@ngrx/store/src/models';
import { SCREEN_SIZE_BREAKPOINTS } from '../../configurations/application.config';
import { APPLICATION_ACTIONS } from '../actions/application.actions';
import { INavItem } from '../../../layout/navigation/models/nav-item.model';

export const APPLICATION_STATE_KEY = 'application';

export interface IApplicationState {
  paused: boolean;
  loading: boolean;
  screenSize: number;
  navigation: INavItem[] | null;
}

export const initialState: IApplicationState = {
  paused: false,
  loading: true,
  screenSize: SCREEN_SIZE_BREAKPOINTS.lg,
  navigation: null,
};

const _applicationReducer: ActionReducer<IApplicationState> = createReducer<IApplicationState>(
  initialState,
  on(APPLICATION_ACTIONS.showLoader, (state) => ({ ...state, loading: true })),
  on(APPLICATION_ACTIONS.hideLoader, (state) => ({ ...state, loading: false })),
  on(APPLICATION_ACTIONS.setScreenSize, (state, { size }) => ({ ...state, screenSize: size })),
  on(APPLICATION_ACTIONS.configureNavigationComplete, (state, { navigation }) => ({ ...state, navigation })),
);

export const applicationReducer = (state: IApplicationState | undefined, action: Action): IApplicationState =>
  _applicationReducer(state, action);
